import CommissionRepository from '@/shared/http/repositories/realestate/commission'

export default{
  name: 'TotalComission',
  props: ['selectedComissao'],
  data () {
    return {
      paidCommissions: '',
      commissionsPayable: ''
    }
  },
  mounted () {
    CommissionRepository.GetTotalComissoes()
      .then(Response => {
        this.paidCommissions = Response.data.data.qtdQuitadas
        this.commissionsPayable = Response.data.data.qtdAPagar
      })
      .catch(() => {})
  },
  updated () {
    CommissionRepository.GetTotalComissoes()
      .then(Response => {
        this.paidCommissions = Response.data.data.qtdQuitadas
        this.commissionsPayable = Response.data.data.qtdAPagar
      })
      .catch(() => {})
  }
}



// WEBPACK FOOTER //
// ./src/views/private/realestate/commissioncheck/components/TotalComission/TotalComission.js